import Key from 'components/shared/Key/Key';

const TooltipContent = ({ label, index, os }) => {
  const isMac = os === 'mac';

  if (isMac) {
    return (
      <div className="flex items-center gap-1">
        <span>{label}</span> <Key icon="chevron-up-2-linear" /> <span>+</span>
        <Key icon="keys-option" />
        <span>+</span> <Key text={`${index + 1}`} />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <span>{label}</span> <Key text="ctrl" /> <span>+</span> <Key text="alt" />
      <span>+</span> <Key text={`${index + 1}`} />
    </div>
  );
};

export default TooltipContent;
